import { useContext } from "react";
import styles from "./DatabaseSelector.module.css";
import ModalDropdown from "components/shared/modal/ModalDropdown";
import GuiContext from "config/context/guiContext";
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';

const DatabaseSelector = () => {
  const { selected, userData, selectedAccount } = useContext(GuiContext);
  const { selectScope } = useCompositionsContext();

  const handleSelectedAccount = async (val) => {
    let databaseName = val;
    if (!databaseName) return;
    selectedAccount(databaseName);
    selectScope(databaseName);
  };

  return (
    <div className={styles.select_option_group}>
      <div className={styles.label}>
        Database <span>({userData?.accounts?.length})</span>
      </div>
      <div className={styles.select_option_row}>
        <ModalDropdown
          title={selected.selectedAccount || "Database"}
          options={userData?.accounts}
          setOption={(val) => {
            handleSelectedAccount(val);
          }}
        />
      </div>
    </div>
  );
};

export default DatabaseSelector;
